import { useRecordContext } from 'react-admin';
import { Client } from '../types';
import { Box, Typography, Divider } from '@mui/material';
import { Image } from 'mui-image';

export const ClientImage = () => {
  const record = useRecordContext<Client>();
  if (record.image_path == null) {
    return (
      <Box>
        <Typography variant="h6">Client Image</Typography>
        <Divider />
        <Typography color="textSecondary" sx={{ mt: 1 }}>
          No image uploaded
        </Typography>
      </Box>
    );
  } else {
    const imageSrc =
      process.env.REACT_APP_SUPABASE_URL +
      '/storage/v1/object/public/memorial-images/' +
      record.image_path;

    return (
      <Box>
        <Typography variant="h6">Client Image</Typography>
        <Divider />
        <Image src={imageSrc} width={200} />
      </Box>
    );
  }
};
